import React, { useRef } from 'react';
import { Container, Box, Grid, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ChevronRight, ChevronLeft } from 'react-feather';
import i18n from 'i18next';
import Link from 'next/link';

const Organization = ({ linkData }) => {
    const { t } = useTranslation();
    const containerRef = useRef(null);
    const scrollAmount = 200; // Define the scroll amount

    const handlePrevClick = () => {
        if (containerRef.current) {
            containerRef.current.scrollLeft -= scrollAmount;
        }
    };

    const handleNextClick = () => {
        if (containerRef.current) {
            containerRef.current.scrollLeft += scrollAmount;
        }
    };

    return (
        <Container
            maxWidth="lg"
            disableGutters={true}
            style={{
                display: 'flex',
                cursor: 'pointer',
                padding: 30,
                marginTop: 25,
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <IconButton onClick={handlePrevClick} style={{ zIndex: 10 }}>
                <ChevronLeft />
            </IconButton>
            <Box ref={containerRef} style={{
                display: 'flex',
                overflowX: 'scroll',
                scrollBehavior: 'smooth',
                width: '100%',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                '&::-webkit-scrollbar': {
                    display: 'none',
                },
            }}>
                {linkData && linkData.length > 0 ? (
                    linkData.map((item) => (
                            <Box
                                key={item.id}
                                style={{
                                    padding: 20,
                                    opacity: 0.6,
                                    transition: 'opacity 0.3s ease',
                                }}
                                onClick={() => {
                                    window.open(item.link);
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
                                onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.6')}
                            >
                                <Box
                                    style={{
                                        backgroundPosition: 'center',
                                        position: 'relative',
                                        backgroundImage: `url(${item.imageUrl})`,
                                        height: 100,
                                        width: 155,
                                        backgroundRepeat: 'no-repeat',
                                        backgroundSize: 'contain',
                                    }}
                                />
                                <Box
                                    style={{
                                        padding: 10,
                                        textAlign: 'center',
                                        font: 'bold 15px Roboto, sans-serif',
                                        width: 155,
                                    }}
                                >
                                    {i18n.language === 'en' ? item.descriptionEng : item.description}
                                </Box>
                            </Box>
                    ))
                ) : (
                    <Grid item xs={12}>
                        <Typography variant="h6" align="center">
                            No data available
                        </Typography>
                    </Grid>
                )}
            </Box>
            <IconButton onClick={handleNextClick} style={{ zIndex: 10 }}>
                <ChevronRight />
            </IconButton>
        </Container>
    );
};

export default Organization;
